import React from 'react';
import PropTypes from 'prop-types';
import { withProps } from 'recompose';
import { isNumber, slice } from 'lodash';

import { Container, Group } from 'components/core/Page';
import { H1, Text } from 'components/core/Typography';
import { LocationSearchBox } from 'components/search/LocationSearchBox';
import { TopPromoCards } from 'components/landing/TopPromoCards';

import './storageDealsHero.scss';

export const enhance = withProps(({ promoFacilitiesCount, fmfFacilitiesCount, facilities }) => {
	let promoMessage;
	if (isNumber(promoFacilitiesCount) && isNumber(fmfFacilitiesCount)) {
		const nonFmfFacilitiesCount = promoFacilitiesCount - fmfFacilitiesCount;
		if (nonFmfFacilitiesCount === 0 && fmfFacilitiesCount === 0) {
			promoMessage = 'There are no deals available, but here are some other facilities that might interest you!';
		} else if (fmfFacilitiesCount && fmfFacilitiesCount > 0) {
			promoMessage = 'Hurry! 1st Month Free offers don\'t last long!';
		} else if (nonFmfFacilitiesCount && nonFmfFacilitiesCount > 0) {
			promoMessage = 'There are no 1st Month Free deals available, ' +
				'but here are some other deals that might interest you!';
		}
	}
	let filteredFacilities = facilities.filter((facility) => facility.inNetwork);
	filteredFacilities = slice(filteredFacilities, 0, 3);

	// We need to have at least one filtered facility before getting into the loop
	while (filteredFacilities.length && filteredFacilities.length < 3) {
		filteredFacilities.push({ isGhost: true });
	}

	return { promoMessage, facilities: filteredFacilities };
});

export function StorageDealsHero({
	promoMessage,
	promoFacilitiesCount,
	facilities
}) {
	const fmfBadgeMessageResult = facilities.filter((facility) => facility.hasFmf);
	return (
		<div className="storage-deals-hero">
			<Container className="storage-deals-container">
				<Group>
					<H1 size="huge" className="head-fmf">
						Get Your First Month of Storage
						{' '}
						<Text size="huge" highlight="green">FREE</Text>
					</H1>
				</Group>
				{!!promoMessage &&
					<Group className="deals-alert-group">
						<Text color="black" weight="standard">
							{promoMessage}
						</Text>
					</Group>
				}
				<LocationSearchBox
					inputLabel="Enter address, city or zip"
					searchPath="/storage-deals.html"
				/>
				<TopPromoCards
					fmfBadgeMessage={!!fmfBadgeMessageResult.length}
					facilities={facilities}
					promoFacilitiesCount={promoFacilitiesCount}
				/>
			</Container>
		</div>
	);
}

StorageDealsHero.propTypes = {
	promoMessage: PropTypes.string,
	promoFacilitiesCount: PropTypes.number,
	facilities: PropTypes.arrayOf(PropTypes.object)
};

export default enhance(StorageDealsHero);
